import {
  LISTAR_URAS,
  LISTAR_AUDIOS,
  LISTAR_TRONCOS,
  LISTAR_ROTAS,
  LISTAR_CENTRO_DE_CUSTOS,
  LISTAR_GRUPOS_ATENDIMENTO,
  LISTAR_FILAS,
  LISTAR_WEBHOOKS,
  LISTAR_REGEXES,
  LISTAR_CONFERENCIAS,
  LISTAR_MUSICAS_EM_ESPERA,
  LISTAR_AVALIACOES_ATENDIMENTO,
  LISTAR_TAGS,
} from './mutation-types'
import regrasDeNegocioHttpService from '../services/regrasDeNegocioHttpService'

export default {
  listarUras: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getUras()
      commit(LISTAR_URAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarAudios: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getAudios()
      commit(LISTAR_AUDIOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarTroncos: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getTroncos()
      commit(LISTAR_TRONCOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRotas: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getrotas()
      commit(LISTAR_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarCentroDeCustos: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getCentroDeCustos()
      commit(LISTAR_CENTRO_DE_CUSTOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGruposAtendimento: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getGruposRamais()
      commit(LISTAR_GRUPOS_ATENDIMENTO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarFilas: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getFilas()
      commit(LISTAR_FILAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarWebhooks: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getWebhooks()
      commit(LISTAR_WEBHOOKS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRegex: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getAllRegex()
      commit(LISTAR_REGEXES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarConferencias: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getConferencias()
      commit(LISTAR_CONFERENCIAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarMusicasEmEspera: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getMusicasEmEspera()
      commit(LISTAR_MUSICAS_EM_ESPERA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarAvaliacoesAtendimento: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getTodasPesquisasSatisfacao()
      commit(LISTAR_AVALIACOES_ATENDIMENTO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarTags: async ({ commit }) => {
    try {
      const response = await regrasDeNegocioHttpService.getTags()
      commit(LISTAR_TAGS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
